import { Component, Input, OnInit } from '@angular/core';
import { map, Observable, of, switchMap } from 'rxjs';
import { Funding } from 'src/app/common/models/funding';
import { Identifier } from 'src/app/common/models/identifier';
import { DetailsService } from 'src/app/common/services/details.service';

@Component({
  selector: 'rpc-funding',
  templateUrl: './more-info-funding.component.html',
  styleUrls: ['./more-info-funding.component.scss']
})
export class MoreInfoFundingComponent implements OnInit {

  @Input()
  irbNumber!: string;
  funding$!: Observable<Funding[]>;


  constructor(
    private detailsService: DetailsService
  ) {
  }

  ngOnInit(): void {
    if (this.detailsService.studyDetails?.fundingOrgs) {
      this.funding$ = of(this.detailsService.studyDetails.fundingOrgs);
    } else {
      this.funding$ = this.detailsService.getStudyTitleV2(this.irbNumber).pipe(
        switchMap(titleInfo =>
          this.detailsService.getStudyDetail(titleInfo.mayoIrbNumber).pipe(
            map(studyDetails =>
              // Return funding orgs
              studyDetails?.fundingOrgs ?? []
            )
          )
        )
      );
    }
  }

}
